import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Card from '../card/Card.jsx';
import Row from '../layout/Row.jsx';
import i18n from '../i18n/index.js';
import en from '../i18n/lang/en.js';
import cn from '../i18n/lang/zh-CN.js';
import jp from '../i18n/lang/jp.js';
import Column from '../layout/Column.jsx';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "international-国际化"
    }}>{`International 国际化`}</h1>
    <p>{`国际化内容显示，可以设置不同国家语言的内容`}</p>
    <h2 {...{
      "id": "基本使用"
    }}>{`基本使用`}</h2>
    <Playground __position={0} __code={'<div>\n  {i18n.use(en)}\n  <Card header={i18n.t(\'hui.select.loading\')}>\n    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(value => {\n      return <span>{i18n.t(`hui.datepicker.month${value}`)} </span>\n    })}\n  </Card>\n</div>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Card,
      Row,
      i18n,
      en,
      cn,
      jp,
      Column,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <div>
        {i18n.use(en)}
        <Card header={i18n.t("hui.select.loading")} mdxType="Card">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(value => {
            return <span>{i18n.t(`hui.datepicker.month${value}`)} </span>;
          })} 
        </Card>
    </div>
    </Playground>
    <Playground __position={1} __code={'<div>\n  {i18n.use(cn)}\n  <Card header={i18n.t(\'hui.select.loading\')}>\n    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(value => {\n      return <span>{i18n.t(`hui.datepicker.month${value}`)} </span>\n    })}\n  </Card>\n</div>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Card,
      Row,
      i18n,
      en,
      cn,
      jp,
      Column,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <div>
        {i18n.use(cn)}
        <Card header={i18n.t("hui.select.loading")} mdxType="Card">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(value => {
            return <span>{i18n.t(`hui.datepicker.month${value}`)} </span>;
          })}
        </Card>
    </div>
    </Playground>
    <Playground __position={2} __code={'<div>\n  {i18n.use(jp)}\n  <Card header={i18n.t(\'hui.select.loading\')}>\n    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(value => {\n      return <span>{i18n.t(`hui.datepicker.month${value}`)} </span>\n    })}\n  </Card>\n</div>\n{i18n.use(cn)}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Card,
      Row,
      i18n,
      en,
      cn,
      jp,
      Column,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <div>
        {i18n.use(jp)}
        <Card header={i18n.t("hui.select.loading")} mdxType="Card">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(value => {
            return <span>{i18n.t(`hui.datepicker.month${value}`)} </span>;
          })}
        </Card>
    </div>
    {i18n.use(cn)}
    </Playground>
    <h2 {...{
      "id": "使用说明"
    }}>{`使用说明`}</h2>
    <ol>
      <li parentName="ol">{`在使用该组件前，需要使用`}<inlineCode parentName="li">{`i18n.use`}</inlineCode>{`方法引用语言，现支持`}<strong parentName="li">{`中文（简体），中文（繁体），英文，意大利语，韩语，日语，俄语`}</strong>{`.`}</li>
      <li parentName="ol">{`引用语言后，使用`}<inlineCode parentName="li">{`i18n.t`}</inlineCode>{`方法指定对应需要显示的内容，`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      